<template>
  <div class="fle flex-col items-start w-full">
    <div
      class="sticky top-0 bg-TERTIARY z-10 flex flex-row items-center justify-between w-full px-4 relative"
      :class="isScrolled ? 'py-4 border-b border-GREY' : 'py-2.5'"
    >
      <div class="flex items-center gap-3">
        <button @click="$router.back()"><font-awesome-icon icon="fa-solid fa-arrow-left" /></button>
        <p class="text-sm text-white font-semibold">Store</p>
      </div>
      <div  class="flex items-center justify-center bg-WHITE rounded-xl p-2">
        <font-awesome-icon  class="black-icon h-3 w-3" icon="fa-regular fa-bookmark" />
      </div>

      <div
        class="absolute inset-0 m-auto w-[40px] h-[40px] border border-2 border-WHITE rounded-xl flex justify-center items-center"
        v-if="isScrolled"
      >
      <img class="rounded-xl  object-contain w-fit h-[38px]" src="@/assets/images/temp-pp.jpeg" alt="" />
      </div>
    </div>
    <div class="fle flex-col items-start w-full px-4 pb-4">
      <div class="rounded-xl border border-2 border-WHITE w-fit mt-5">
      <img class="rounded-xl w-[60px] h-[60px]" src="@/assets/images/temp-pp.jpeg" alt="" />
    </div>
    <p class="text-sm font-semibold text-start mt-2.5">Ghozali Everyday</p>
    <p class="text-xs text-start mt-1">25 NFT</p>
    <div class="flex flex-col gap-2 w-full">
      <div class="flex flex-row gap-2 items-center mt-3">
        <font-awesome-icon icon="fa-regular fa-user" />
        <p class="text-GREY text-xs">Created by</p>
        <p class="text-xs">Oğuzhan Yıldız</p>
      </div>
      <div class="flex flex-row gap-2 items-center">
        <font-awesome-icon icon="fa-regular fa-calendar " />
        <p class="text-GREY text-xs">Create Date</p>
        <p class="text-xs">12 August 2024</p>
      </div>
    </div>

    <div class="border-t border-0.5 border-GREY rounded-full my-5"></div>
    <p class="text-sm font-semibold text-start mb-3">Description</p>
    <p class="text-GREY text-sm text-start">
      Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.
      <br />
      Lorem ipsum dolor sit amet consectetur. Arcu ultricies mus sed odio sit vitae elementum donec
      sit. Ac mi tortor morbi sed. Elit aliquam porta consequat lacus dui ut. Gravida quam ultricies
      nibh lectus donec vulputate ornare viverra. A pulvinar.
    </p>
    <div class="rounded-lg bg-[#061527] flex flex-row justify-between items-center p-2 my-5">
      <div class="flex flex-col justify-center items-center min-w-[80px]">
        <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-eye" />
        <p class="text-xs font-medium mt-2">122K</p>
        <p class="text-GREY text-[10px] mt-0.5">Views</p>
      </div>
      <div class="border-l h-[60px] border-1 border-GREY rounded-full"></div>

      <div class="flex flex-col justify-center items-center min-w-[80px]">
        <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-bookmark" />
        <p class="text-xs font-medium mt-2">195</p>
        <p class="text-GREY text-[10px] mt-0.5">Favorite</p>
      </div>
      <div class="border-l h-[60px] border-1 border-GREY rounded-full"></div>
      <div class="flex flex-col justify-center items-center min-w-[80px]">
        <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-user" />
        <p class="text-xs font-medium mt-2">1</p>
        <p class="text-GREY text-[10px] mt-0.5">Owners</p>
      </div>
    </div>
    <div class="flex flex-col gap-4 items-start w-full">
      <p class="text-sm font-semibold">Items</p>
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 md:grid-cols-5 gap-4 w-full">
        <nft-card
          @click="router.push({ name: 'NftDetailPage' })"
          v-for="nft in tempNftData"
          :nft-data="nft"
        >
          <div :class="nft.state == 'owned'" class="gap-2.5 flex flex-col items-start min-h-[60px]">
            <p class="font-semibold text-sm">{{ nft.name }}</p>
            <div
              v-if="nft.state == 'sale'"
              class="flex flex-row gap-2 justify-center w-full items-center"
            >
              <pow-button size="xs" tertiary class="w-full">
                <div class="flex flex-row gap-0.5 items-center">
                  <p class="text-xs">Buy for (</p>
                  <img src="@/assets/icons/token-2.svg" class="h-3 object-contain" />
                  <p class="text-xs">150 )</p>
                </div>
              </pow-button>
            </div>
            <p v-else-if="nft.state == 'owned'" class="text-xs">Owned</p>
            <div v-else-if="nft.state == 'bought'" class="flex flex-col gap-1 items-start">
              <p class="text-xs text-GREY">Owned by</p>
              <p class="text-xs text-GREY underline">walletmarhennan</p>
            </div>
          </div>
        </nft-card>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script setup>
import PowButton from '../PowButton.vue'
import NftCard from '../NftCard.vue'
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const tempNftData = ref([
  {
    name: 'Factura by Ahmet',
    type: 'SSR',
    price: '100',
    stock: '100',
    state: 'sale'
  },
  {
    name: 'Aloha by Oğuz',
    type: 'R',
    price: '300',
    stock: '210',
    state: 'bought'
  },
  {
    name: 'Vice Captain',
    type: 'SR',
    price: '150',
    stock: '50',
    state: 'owned'
  }
])

const isScrolled = ref(false)
const stickyPoint = 100 

const handleScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  isScrolled.value = scrollTop > stickyPoint
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
